const FJTextBaseEditingUtil = {
    /**
     * @desc 时间线播放时长转资源当前时长
     * @param {number} time
     * @returns {number}
     */
    timeLineCurrentTimeToSourceCurrentTime: function (time, splitTimeList = [], startTime = 0) {
        let currentTime = time;
        if (splitTimeList && splitTimeList.length > 0) {
            let total = 0;

            for (let i = 0; i < splitTimeList.length; i++) {
                const item = splitTimeList[i];
                total += item.endTime - item.startTime;

                if (total >= currentTime) {
                    currentTime = item.endTime - (total - currentTime);
                    break;
                }

                // 如果当前时间大于总时间，则将当前时间设置为总时间
                if (i === splitTimeList.length - 1) {
                    currentTime = item.endTime;
                    break;
                }
            }
        } else {
            currentTime = time + startTime;
        }

        return currentTime;
    },

    /**
     * @desc 资源当前时长转时间线播放时长
     * @param {number} time
     * @returns {number}
     */
    sourceCurrentTimeToTimeLineCurrentTime: function (time, splitTimeList) {
        let currentTime = time;
        let total = 0;
        if (splitTimeList && splitTimeList.length > 0) {
            for (let i = 0; i < splitTimeList.length; i++) {
                const item = splitTimeList[i];
                if (item.startTime > currentTime) {
                    currentTime = total;
                    break;
                } else if (item.startTime <= currentTime && item.endTime >= currentTime) {
                    currentTime = total + (currentTime - item.startTime);
                    break;
                }

                total += item.endTime - item.startTime;
                if (i === splitTimeList.length - 1) {
                    currentTime = total;
                }
            }
        }

        return currentTime;
    },
};

export default FJTextBaseEditingUtil;
